jQuery(function($) {

    // $('.block019_cta5050').each(function() {
    //     var $height = $(this).children('.content').css( 'height' );
    // });

});